import {  get, publicPost,post, put, deleteRequest } from "../../helpers/apihelpers";

export const TeacherLogInService = async (data)=>{
    try {
      const result = await publicPost(`api/teacher/login`, data);
      return result;
    } catch (err) {
      return err.response;
    }
}

export const CreateTeacherService=async(data)=>{
    try {
        const result = await publicPost(`api/teacher/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetTeacherSearchService = async (search,page,type='',mode='',show_in_feedback='')=>{
  try {
    const result = await get(`api/teacher/search?search=${search}&page=${page}&type=${type}&mode=${mode}&show_in_feedback=${show_in_feedback}`);
    return result;
  } catch (err) {
    return err.response;
  }
}

export const UpdateTeacherPasswordService = async (data,id)=>{
  try {
    const result = await post(`api/teacher/change-password-admin`, data);
    return result;
  } catch (err) {
    return err.response;
  }
}


export const UpdateTeacherPassword1Service = async (data,id)=>{
  try {
    const result = await put(`api/teacher/change-password`, data);
    return result;
  } catch (err) {
    return err.response;
  }
}

export const UpdateTeacherService=async(data,id)=>{
    try {
        const result = await post(`api/teacher/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteTeacherService=async(id)=>{
    try {
        const result = await deleteRequest(`api/teacher/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetTeacherDetailService=async(id)=>{
    try {
        const result = await get(`api/teacher/get/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetTeacherListService=async(page)=>{
    try {
        const result = await get(`api/teacher/get/${page}`,);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateTeacherRoleService = async (data) => {
    try {
        const result = await put(`api/teacher/assign-user-roles`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const getMyTeacherProfile = async (id) =>{
  try {
    const result = await get(`api/teacher/profile/${id}`);
    return result;
  } catch (err) {
    return err.response;
  }
}
